document.addEventListener("DOMContentLoaded", function () {
    let productForm = document.querySelector("form[action$='cart/add']");
    if (!productForm) return;

    let productPriceElement = document.querySelector("[data-product-price]"); 
    let quantityInput = productForm.querySelector("input[name='quantity']") || document.createElement("input");
    
    quantityInput.type = "number";
    quantityInput.value = 1;
    quantityInput.min = 1;
    quantityInput.name = "quantity";

    let stickyCart = document.createElement("div");
    stickyCart.id = "sticky-add-to-cart";
    stickyCart.innerHTML = `
        <div class="sticky-cart-content">
            <div class="sticky-qty-container">
                <button id="sticky-qty-minus">−</button>
                <input type="number" id="sticky-qty" value="${quantityInput.value}" min="1">
                <button id="sticky-qty-plus">+</button>
            </div>
            <div class="sticky-price">
                <span id="sticky-product-price">${productPriceElement ? productPriceElement.innerText : "$0.00"}</span>
                <span id="sticky-total-price"></span>
            </div>
            <button id="sticky-cart-button">Add to Cart</button>
        </div>
    `;
    document.body.appendChild(stickyCart);

    let stickyQtyInput = document.getElementById("sticky-qty");
    let stickyProductPrice = document.getElementById("sticky-product-price");
    let stickyTotalPrice = document.getElementById("sticky-total-price");

    function getCurrentProductPrice() {
        return parseFloat(stickyProductPrice.innerText.replace(/[^0-9.]/g, "")) || 0;
    }

    function updateTotalPrice() {
        let basePrice = getCurrentProductPrice();
        let qty = parseInt(stickyQtyInput.value);
        stickyTotalPrice.innerText = `$${(basePrice * qty).toFixed(2)}`;
    }

    document.getElementById("sticky-qty-minus").addEventListener("click", function () {
        if (stickyQtyInput.value > 1) {
            stickyQtyInput.value--;
            updateTotalPrice();
        }
    });

    document.getElementById("sticky-qty-plus").addEventListener("click", function () {
        stickyQtyInput.value++;
        updateTotalPrice();
    });

    stickyQtyInput.addEventListener("input", updateTotalPrice);

    document.getElementById("sticky-cart-button").addEventListener("click", function () {
        let mainQtyInput = productForm.querySelector("input[name='quantity']");
        if (mainQtyInput) {
            mainQtyInput.value = stickyQtyInput.value;
        }
        productForm.querySelector("button[type=submit]").click();
    });

    function updatePriceOnVariantChange() {
        let updatedPrice = document.querySelector("[data-product-price]");
        if (updatedPrice) {
            stickyProductPrice.innerText = updatedPrice.innerText;
            updateTotalPrice();
        }
    }

    let variantSelectors = document.querySelectorAll("select[name='id'], input[name='id']");
    variantSelectors.forEach(selector => {
        selector.addEventListener("change", updatePriceOnVariantChange);
    });

    function toggleStickyCart() {
        let addToCartButton = productForm.querySelector("button[type=submit]");
        if (window.scrollY > addToCartButton.getBoundingClientRect().top + window.scrollY + 100) {
            stickyCart.style.display = "flex";
        } else {
            stickyCart.style.display = "none";
        }
    }

    window.addEventListener("scroll", toggleStickyCart);
    updateTotalPrice();
    toggleStickyCart();
});
